import { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useBadgeNotifications() {
  const { user, token } = useAuth();
  const [pendingBadges, setPendingBadges] = useState([]);
  const [currentBadge, setCurrentBadge] = useState(null);
  const intervalRef = useRef(null);

  const checkPending = useCallback(async () => {
    if (!user || user.role !== 'student' || !token) return;
    try {
      const res = await axios.get(`${API}/gamification/pending-badges/${user.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data && res.data.length > 0) {
        setPendingBadges(prev => [...prev, ...res.data.map(p => p.badge)]);
      }
    } catch (err) { console.error('Failed to fetch badge notifications:', err); }
  }, [user, token]);

  useEffect(() => {
    if (user?.role === 'student') {
      checkPending();
      intervalRef.current = setInterval(checkPending, 10000);
      return () => clearInterval(intervalRef.current);
    }
  }, [user, checkPending]);

  useEffect(() => {
    if (!currentBadge && pendingBadges.length > 0) {
      setCurrentBadge(pendingBadges[0]);
      setPendingBadges(prev => prev.slice(1));
    }
  }, [currentBadge, pendingBadges]);

  const dismissBadge = () => {
    setCurrentBadge(null);
  };

  const triggerCheck = () => {
    checkPending();
  };

  return { currentBadge, dismissBadge, triggerCheck };
}
